import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['bridge', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-2h4v0.5h-4zM-3.5,-1.5h6v0.5h-6zM-4.5,-1h0.5v0.5h-0.5zM-3.5,-1h7.5v0.5h-7.5zM-4.5,-0.5h2.5v0.5h-2.5zM-1.5,-0.5h0.5v0.5h-0.5zM3,-0.5h1.5v0.5h-1.5zM-5,0h2.5v0.5h-2.5zM-4.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['bridge', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2,-0.5h0.5v0.5h-0.5zM-1,-0.5h4v0.5h-4zM-2.5,0h3v0.5h-3zM1.5,0h3v0.5h-3zM-3.5,0.5h1.5v0.5h-1.5zM3.5,0.5h2v0.5h-2zM-4,1h1v0.5h-1zM5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-4h1.5v0.5h-1.5zM-3,-3.5h5.5v0.5h-5.5zM-4,-3h2v0.5h-2zM-0.5,-3h1v0.5h-1zM1.5,-3h1.5v0.5h-1.5zM-5,-2.5h1.5v0.5h-1.5zM-3,-2.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1.5h-0.5zM-5,-2h0.5v2h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-2.5,-2.5h5v0.5h-5zM-3.5,-2h1.5v0.5h-1.5zM2,-2h0.5v0.5h-0.5zM3,-2h1v0.5h-1zM-4,-1.5h0.5v1h-0.5zM3.5,-1.5h1.5v0.5h-1.5zM4.5,-1h0.5v1.5h-0.5zM-4,0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 141,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
